import React from 'react'
import { Dropdown } from 'react-bootstrap'

export const NoUserDropdownItem = ({ query }: { query: string }) => (
  <Dropdown.Item>No Users {query ? `match "${query}"` : null}</Dropdown.Item>
)
